const tokenData = localStorage.getItem('token') ? localStorage.getItem('token') : null
const profile = JSON.parse(localStorage.getItem('profile')) || {}
const license = JSON.parse(localStorage.getItem('license')) || {
  company: {
    Car_lots: []
  }
}
const system = JSON.parse(localStorage.getItem('system')) || []
const permissions = JSON.parse(localStorage.getItem('permissions')) || []

const initialState = {
  user: {
    isLogged: !!tokenData,
    ...profile,
    license,
    system,
    token: tokenData,
    permissions,
    isMobileSystem: JSON.parse(localStorage.getItem('isMobileSystem') || 'false')
  },
  fileAssociations: {},
  formData: {},
  saveFormDataPending: false,
  saveFormDataError: null,
  loadFormDataPending: false,
  loadFormDataError: null,
  CURRENT_LOG_LEVEL: 0,
  locations: null,
  locationsPending: false,
  locationsError: false,
  canDelete: { can: null, message: '' },
  client: {},
  saveClientDataPending: false,
  saveClientDataError: false,
  customFilters: [],
  modalData: {},
}

export default initialState 
